// Force scroll to top
if (location.hash) {
    window.scrollTo(0, 0);
    setTimeout(function() {
        window.scrollTo(0, 0);
    }, 1);
}

jQuery(document).ready(function ($) {

    // Mobile menu
    let trigger = $('.menutoggle');
    let isClosed = false;

    trigger.click(function () {
        toggleMenu();
    });
    function toggleMenu() {
        let HTML = $('HTML');
        if (isClosed) {
            if (HTML.hasClass('menu-open')) {
                HTML.removeClass('menu-open');
            }
            trigger.removeClass('is-open');
            trigger.addClass('is-closed');
            isClosed = false;
        } else {
            HTML.addClass('menu-open');
            trigger.removeClass('is-closed');
            trigger.addClass('is-open');
            isClosed = true;
        }
    }

    const $languages = $('.languages');
    $languages.on('click', function (event) {
        const target = $(event.target);
        if (target.is('button')) {
            // Check if the current toggle is expanded.
            const isExpanded = target.attr('aria-expanded') === 'true';

            if (!isExpanded) {
                // Set the expanded state on the triggering element
                target.attr('aria-expanded', 'true');
                $languages.addClass('open');
                // Hide the accordion sections, using aria-controls to specify the desired section
                document.getElementById(target.attr('aria-controls')).removeAttribute('hidden');
            }
            else {
                // Set the expanded state on the triggering element
                target.attr('aria-expanded', 'false');
                $languages.removeClass('open');
                // Hide the accordion sections, using aria-controls to specify the desired section
                document.getElementById(target.attr('aria-controls')).setAttribute('hidden', '');
            }

            event.preventDefault();
        }
    });

    const $minicart = $('.cart-mini');
    $('body').on('click', $minicart, function (event) {
        const target = $(event.target);
        if (target.is('button.toggle-cart') || target.is('button.toggle-cart svg')) {
            // Check if the current toggle is expanded.
            const b = $('button.toggle-cart');
            const isExpanded = b.attr('aria-expanded') === 'true';

            if (!isExpanded) {
                // Set the expanded state on the triggering element
                b.attr('aria-expanded', 'true');
                // Hide the accordion sections, using aria-controls to specify the desired section
                document.getElementById(b.attr('aria-controls')).removeAttribute('hidden');
            }
            else {
                // Set the expanded state on the triggering element
                b.attr('aria-expanded', 'false');
                // Hide the accordion sections, using aria-controls to specify the desired section
                document.getElementById(b.attr('aria-controls')).setAttribute('hidden', '');
            }

            event.preventDefault();
        }
    });

    $('#mc4wp-form-1').on('submit', function(e) {
        e.preventDefault();
        $.ajax({
            url : $(this).attr('action') || window.location.pathname,
            type: "POST",
            data: $(this).serialize(),
            success: function () {
                $('#js-mc-subscribe').addClass('hidden');
                $('#js-mc-thank-you').removeClass('hidden');
            },
            error: function (jXHR, textStatus, errorThrown) {
                alert(errorThrown);
            }
        });
    });


    function fadeSection() {
        $('SECTION, FOOTER').each(function() {
            const top_of_object = $(this).position().top;
            const bottom_of_window = $(window).scrollTop() + $(window).height();
            if( bottom_of_window > top_of_object ){
                if( ! $(this).hasClass('section-animate') ) {
                    $(this).addClass('section-animate');
                }
            }
        });
    }
    fadeSection();

    // Sections fade in + sticky
    $(window).scroll(function() {
        fadeSection();
    });


    // Collapsible
    const collapsible = $('.collapsible');

    if (collapsible.length > 0) {
        const collapsibleTrigger = collapsible.find('.toggle');
        collapsible.find('LI:first-child').addClass('expanded');
        collapsibleTrigger.click(function () {
            this.parentElement.classList.toggle('expanded');
        });
    }

    // Tabs switcher
    // TODO: If index not found, default to first tab
    const tabs = $('.main-tabs-wrapper');

    if (tabs.length > 0) {

        const tabsTriggerSelector = tabs.find('.tabs > LI > A');
        const tabsContentSelector = tabs.find('.tabs-content > DIV');
        let hash = window.location.hash;

        handleTabs(hash);

        tabsTriggerSelector.click(function(event) {
            event.preventDefault();
            window.location.hash = this.hash;
            handleTabs(window.location.hash);
        });

        $(window).on('hashchange', function() {
            handleTabs(window.location.hash);
        });

        function handleTabs (hash) {
            if (!hash) {
                const first = tabsTriggerSelector.first().attr('href');
                hash = first;
                window.location.hash = first;
            }
            const selectedContent = '[data-key=' + hash.substr(1) + ']';
            const selectedTrigger = '[href="' + hash + '"]';
            let timer1 = 0;
            let timer2 = 0;
            $('.tabs-content').addClass('transition');
            timer2 = setTimeout(function () {
                tabsContentSelector.removeClass('active');
                tabsTriggerSelector.removeClass('active');
                $(selectedContent + ', ' + selectedTrigger).addClass('active');
            }, 200);
            timer1 = setTimeout(function () {
                $('.tabs-content').removeClass('transition');
            }, 400);
        }
    }

        // Slides
    const s = $('.hero-slider .slick').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        pauseOnDotsHover: true
    });
    let bPaused = false;
    $('#toggleSlider').click(function(){
        if( bPaused === false){
            bPaused = true;
            $('.hero-slider .slick').slick('slickPause');
        } else {
            bPaused = false;
            $('.hero-slider .slick').slick('slickPlay');
        }


    });

    // Scrolling
    $(window).scroll(function() {
        const scroll = $(window).scrollTop();
        if (scroll >= 1) {
            $('HTML').addClass('scroll');
        } else {
            $('HTML').removeClass('scroll');
        }
    });

    /*$('.hero-slider .video').each(function(el){
        alert('x');
        console.log(el);
       $('.container',el).click(function(e){
           alert('click');
           if(!e.currentTarget.hasClass('button')){
               $('.mejs-playpause-button',el).find('button').click();
           }
       });
    });*/

    $(window).trigger('scroll');

    $('[data-action="scroll"]').each(function () {
        let hash = window.location.hash;

        var list = $(this),
            h = list.outerHeight() + 15,
            // All list items
            items = list.find("a:not(.noscroll)"),
            // Anchors corresponding to menu items
            scrollItems = items.map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });
        // Bind to scroll
        $(window).scroll(function () {
            // Get container scroll position
            var fromTop = $(this).scrollTop() + h,
                cur,
                id;

            // Get id of current scroll item
            cur = scrollItems.map(function () {
                if ($(this).offset().top < fromTop) {
                    return this;
                }
            });
            // Get the id of the current element
            cur = cur[cur.length - 1];
            id = cur && cur.length ? cur[0].id : "";
            // Set/remove active class
            items
                .parent().removeClass("active")
                .end().filter("[href='#" + id + "']").parent().addClass("active");
        });
        if(hash){
            console.log(list.find('A[href="'+hash+'"]'));
            list.find('A[href="'+hash+'"]').click();
        }
    });
});